// @flow

const finder = (id: string) => document.getElementById(id); // eslint-disable-line no-undef

export {
	finder,
};
